import './styles/index.scss';
import { withI18n } from 'panda-i18n';
import locale from "../../locales";
import { CnSearch as CnSearchView } from './search';
export var CnSearch = withI18n(CnSearchView, { locale: locale });
